import { render, staticRenderFns } from "./CrudEdit.vue?vue&type=template&id=062f5934&scoped=true&"
import script from "./CrudEdit.vue?vue&type=script&lang=js&"
export * from "./CrudEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062f5934",
  null
  
)

export default component.exports